import { render, staticRenderFns } from "./select-contact.vue?vue&type=template&id=f9410e98&lang=pug&"
import script from "./select-contact.vue?vue&type=script&lang=ts&"
export * from "./select-contact.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports